import {
  DiagnosticEventDTO,
  SortDirection,
} from 'src/app/base/models/models.swagger.generated';
import { defineDynamicEntityDefinition, textColumn } from 'src/app/base/shared/dynamic/dynamic-entity-definition';

export const diagnosticEventsDynamicDefinition = defineDynamicEntityDefinition<DiagnosticEventDTO, DiagnosticEventDTO, DiagnosticEventDTO>({
  entityName: 'diagnostic-event',
  primaryKey: 'id',
  defaultSort: {
    field: 'Timestamp',
    direction: SortDirection.Descending,
  },
  grid: {
    searchFields: [],
    columns: [
      { field: 'id', headerKey: 'i18n.shared.fields.id', type: 'number', visible: false, sortable: false, allowFiltering: false },
      { field: 'vehicleId', headerKey: 'i18n.domain.analytics.diagnostic-events.columns.vehicle-id', type: 'number', visible: false },
      {
        field: 'ecuId',
        headerKey: 'i18n.domain.analytics.diagnostic-events.columns.ecu-id',
        type: 'number',
        filter: { kind: 'number' },
      },
      textColumn<DiagnosticEventDTO>('eventType', 'i18n.domain.analytics.diagnostic-events.columns.event-type'),
      {
        field: 'timestamp',
        headerKey: 'i18n.domain.analytics.diagnostic-events.columns.timestamp',
        type: 'date',
        clipMode: 'EllipsisWithTooltip',
        filter: { kind: 'date' },
        formatValue: (row: DiagnosticEventDTO) => row.timestamp ? row.timestamp.toFormat('dd.MM.yyyy HH:mm') : '',
      },
    ],
  },
  form: {
    fields: [],
    layout: [],
  },
  // Diagnostic event data is read-only (StatisticsController only exposes SearchDiagnosticEvents) — add/edit are never triggered
  // since the grid disables allowAdding/allowEditing/allowDeleting, so these are unused identity pass-throughs.
  mapToCreate: (formValue: DiagnosticEventDTO): DiagnosticEventDTO => formValue,
  mapToUpdate: (formValue: DiagnosticEventDTO): DiagnosticEventDTO => formValue,
});
